import type { Subcategory } from '~/entities/categories'
import { getFacetOptions } from './get-facet-options'

export function getPossibleOutcomes({
  phase,
  subcategories,
}: {
  phase: string
  subcategories: Subcategory[]
}) {
  return getFacetOptions({
    subcategories: subcategories.filter(({ metadata }) => metadata.phase.label === phase),
    selectFacet: ({ metadata }) => metadata.outcome,
  })
}
